export default __webpack_public_path__ + "5b6d1c69f3760efa2ce8f9feb05a5a6e.jpg";